import React, { useEffect, useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ButtonInfo from "../common/button/ButtonInfo";
import AppIcons from "../../utils/AppIcons";
import CHElement from "../../model/CHElement";
import ImgUtil from "../../utils/ImgUtil";
import TimeUtil from "../../utils/TimeUtil";
import EntityStats from "../../model/EntityStats";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";
import EmbeddingToolInfo from "../../utils/EmbeddingToolInfo";

interface IChElementsListElementProps {
  data: CHElement;
  displayRows: boolean;
  onShowOnMap: (data: CHElement) => void;
}

function ChElementsListElement({
  data,
  displayRows,
  onShowOnMap,
}: IChElementsListElementProps) {
  // reference to the navigator
  const navigate = useNavigate();

  if (displayRows)
    return (
      <div
        className="list-row"
        onClick={() => {
          navigate(
            SETTINGS.get_path({
              section: AppSections.CHELEMENTS,
              id: data.id,
              subsection: AppSubSections.VIEW,
            }),
          );
        }}
      >
        {data.icon && (
          <div
            className="list-row-icon"
            style={{
              backgroundImage: `url(${ImgUtil.display_icon(data.icon_path)})`,
            }}
          ></div>
        )}
        <div className="list-row-content">
          <div className="list-row-header">
            <div className="list-row-title">
              <h3>{data.name}</h3>
            </div>
            <div>
              {false && EmbeddingToolInfo.isChemiAnalysis() && (
                <Button
                  label="Open in ChemiAnalysis"
                  purpose={ButtonAction.USE}
                  type={ButtonType.ICON_TEXT}
                  className="btn-use-text"
                  onClick={() => {
                    const payload = "unity:chelement_id=" + data.id;
                    if (EmbeddingToolInfo.isToolOnWindows()) {
                      // @ts-ignore
                      uwb.ExecuteJsMethod("JSCallback", payload);
                    } else {
                      window.location.href = payload;
                    }
                  }}
                />
              )}
              {!EmbeddingToolInfo.isChemiTool() &&
                data.latitude &&
                data.longitude && (
                  <Button
                    onClick={() => {
                      onShowOnMap(data);
                    }} // Use the wrapper
                    label="Show on map"
                    purpose={ButtonAction.MAP}
                    type={ButtonType.ICON_TEXT}
                  />
                )}
              {!EmbeddingToolInfo.isChemiTool() &&
                (!data.latitude || !data.longitude) && (
                  <div className="form-error">
                    {AppIcons.MAP} Missing coordinates
                  </div>
                )}
            </div>
          </div>

          <div className="list-row-description">{data.description}</div>
          <div className="list-row-footer">
            <ButtonInfo>
              {AppIcons.CLOCK}
              Last update: <span>{TimeUtil.display_date(data.created_on)}</span>
            </ButtonInfo>
            <ButtonInfo>
              {AppIcons.USER}
              Created by: <span>{data.username}</span>
            </ButtonInfo>
          </div>
        </div>
      </div>
    );
  else
    return (
      <div
        className="details-grid-element"
        onClick={() => {
          navigate(
            SETTINGS.get_path({
              section: AppSections.CHELEMENTS,
              id: data.id!,
              subsection: AppSubSections.VIEW,
            }),
          );
        }}
      >
        <div
          className="details-grid-icon"
          style={{
            backgroundImage: `url(${ImgUtil.display_icon(data.icon_path)})`,
          }}
        ></div>
        <div className="details-grid-content">
          <div className="details-grid-description">
            <div>
              <h3>{data.name}</h3>
            </div>
            <p>{data.description}</p>
          </div>
          <div className="details-grid-statistics">
            <ButtonInfo>
              {AppIcons.CLOCK}
              created on <span>{TimeUtil.display_date(data.created_on)}</span>
            </ButtonInfo>
            <ButtonInfo>
              {AppIcons.USER}
              created by: <span>{data.username}</span>
            </ButtonInfo>
            <ButtonInfo>
              {AppIcons.E3D}
              <span>
                {EntityStats.getStats(
                  data.counts,
                  ChemiNovaEntityType.E3DMODEL,
                )}
              </span>
              e3Ds
            </ButtonInfo>
            <ButtonInfo>
              {AppIcons.ANNOTATIONS}
              <span>
                {EntityStats.getStats(
                  data.counts,
                  ChemiNovaEntityType.ANNOTATION,
                )}
              </span>
              annotations
            </ButtonInfo>
            <ButtonInfo>
              {AppIcons.DOCUMENTS}
              <span>
                {EntityStats.getStats(
                  data.counts,
                  ChemiNovaEntityType.ANNEX_DATA,
                )}
              </span>
              documents
            </ButtonInfo>
          </div>
        </div>
      </div>
    );
}

export default ChElementsListElement;
